module.exports = __webpack_public_path__ + "static/media/state-14.e996f852.jpg";